import React, { useEffect, useState } from "react";
import axios from "axios";
import { Button } from "./button";
import { Card, CardContent } from "./card";
import { toast } from "react-toastify";

import InputField from "./InputField";
import SelectField from "./SelectField";
import TextAreaField from "./TextAreaField";

const Periodicidades = [
  "semanal",
  "mensual",
  "bimestral",
  "trimestral",
  "semestral",
  "anual",
];

const ClasesRiesgo = [
  "Clase I",
  "Clase IIA",
  "Clase IIB",
  "Clase III",
  "No aplica",
];

const ClasesTecno = [
  "Electrónico",
  "Electromecánico",
  "Mecánico",
  "Hidráulico",
  "Eléctrico",
  "Neumático",
  "Acústico",
  "No aplica",
];

const Clasificacion = [
  "Análisis de Laboratorio",
  "Prevención",
  "Diagnostico",
  "Tratamiento y Mantenimiento de la Vida",
  "Apoyo",
  "No aplica",
];

const Usos = [
  "Médico",
  "Industrial",
  "Laboratorio",
  "Básico",
  "Apoyo",
  "Medio de Transporte",
  "No aplica",
];

const Calibraciones = ["si", "no"];

// 🔹 Adaptador local (NO cambia lógica)
const toOptions = (arr) => arr.map((v) => ({ _id: v, name: v }));

const MantenimientoModal = ({
  marcaId,
  modeloId,
  categoriaId,
  onClose,
  onSaved,
}) => {
  const [form, setForm] = useState({
    periocidadMantenimiento: "",
    periocidadCalibracion: "",
    registroTecnico: "",
    descripcionEquipo: "",
    requiereCalibracion: "",
    claseRiesgo: "",
    claseTecno: "",
    clasificacion: "",
    usos: "",
    invima: "",
  });

  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showCategoriaPrompt, setShowCategoriaPrompt] = useState(false);

  const token = localStorage.getItem("token");
  const API = process.env.REACT_APP_API_URL;

  const planActual = localStorage.getItem("planActual") || "FREE";
  const isFreePlan = planActual === "FREE";

  /* ---------------------------------------------------------
     Cargar hoja de vida si ya existe
  --------------------------------------------------------- */
  useEffect(() => {
    const fetchMantenimiento = async () => {
      try {
        const res = await axios.get(
          `${API}/mantenimiento/${marcaId}/${modeloId}`,
          { headers: { Authorization: `Bearer ${token}` } },
        );

        if (res.data) {
          setForm({
            periocidadMantenimiento: res.data.periocidadMantenimiento || "",
            periocidadCalibracion: res.data.periocidadCalibracion || "",
            registroTecnico: res.data.registroTecnico || "",
            descripcionEquipo: res.data.descripcionEquipo || "",
            requiereCalibracion: res.data.requiereCalibracion || "No",
            claseRiesgo: res.data.claseRiesgo || "",
            claseTecno: res.data.claseTecno || "",
            clasificacion: res.data.clasificacion || "",
            usos: res.data.usos || "",
            invima: res.data.invima || "",
          });
        }
      } catch {
        console.warn("No hay configuración previa");
      }
    };

    if (marcaId && modeloId) fetchMantenimiento();
  }, [API, token, marcaId, modeloId]);

  /* ---------------------------------------------------------
     Inputs
  --------------------------------------------------------- */
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((s) => ({ ...s, [name]: value }));
  };

  const validate = () => {
    const required = [
      "periocidadMantenimiento",
      "periocidadCalibracion",
      "registroTecnico",
      "descripcionEquipo",
      "claseRiesgo",
      "claseTecno",
      "clasificacion",
      "usos",
    ];

    for (const k of required) {
      if (!form[k]) {
        toast.error("Falta campo obligatorio: " + k);
        return false;
      }
    }
    return true;
  };

  /* ---------------------------------------------------------
     Guardar hoja de vida
  --------------------------------------------------------- */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    setIsLoading(true);
    try {
      await axios.post(
        `${API}/mantenimiento`,
        { marcaId, modeloId, ...form },
        { headers: { Authorization: `Bearer ${token}` } },
      );

      toast.success("Configuración guardada ✔");
      if (onSaved) onSaved();
      onClose();
    } catch {
      toast.error("Error al guardar");
    } finally {
      setLoading(false);
      setIsLoading(false);
    }
  };

  /* ---------------------------------------------------------
     Render modal
  --------------------------------------------------------- */
  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        <Card className="border-none shadow-none">
          <CardContent className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">
                Configuración de mantenimiento
              </h2>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 text-xl"
              >
                ✕
              </button>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                <SelectField
                  label="Periocidad de mantenimiento *"
                  name="periocidadMantenimiento"
                  value={form.periocidadMantenimiento}
                  onChange={handleChange}
                  options={toOptions(Periodicidades)}
                />

                <SelectField
                  label="Periocidad de calibración *"
                  name="periocidadCalibracion"
                  value={form.periocidadCalibracion}
                  onChange={handleChange}
                  options={toOptions(Periodicidades)}
                />
              </div>

              <TextAreaField
                label="Registro técnico *"
                name="registroTecnico"
                value={form.registroTecnico}
                onChange={handleChange}
              />

              <TextAreaField
                label="Descripción del equipo *"
                name="descripcionEquipo"
                value={form.descripcionEquipo}
                onChange={handleChange}
              />

              <SelectField
                label="¿Requiere calibración? *"
                name="requiereCalibracion"
                value={form.requiereCalibracion}
                onChange={handleChange}
                options={toOptions(Calibraciones)}
              />

              <InputField
                label="Registro Invima *"
                name="invima"
                value={form.invima}
                onChange={handleChange}
              />

              <SelectField
                label="Clasificación *"
                name="clasificacion"
                value={form.clasificacion}
                onChange={handleChange}
                options={toOptions(Clasificacion)}
              />

              <SelectField
                label="Clase de riesgo *"
                name="claseRiesgo"
                value={form.claseRiesgo}
                onChange={handleChange}
                options={toOptions(ClasesRiesgo)}
              />

              <SelectField
                label="Clase de tecnología *"
                name="claseTecno"
                value={form.claseTecno}
                onChange={handleChange}
                options={toOptions(ClasesTecno)}
              />

              <SelectField
                label="Usos *"
                name="usos"
                value={form.usos}
                onChange={handleChange}
                options={toOptions(Usos)}
              />

              {/* BOTONES */}
              <div className="flex justify-end gap-2 pt-4">
                <div className="relative inline-block">
                  <Button
                    type="button"
                    onClick={() => {
                      if (!isFreePlan) setShowCategoriaPrompt(true);
                    }}
                    disabled={
                      isFreePlan ||
                      !categoriaId ||
                      !marcaId ||
                      !modeloId ||
                      loading
                    }
                    className={
                      isFreePlan
                        ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                        : ""
                    }
                  >
                    {loading ? "Generando..." : "Generar con IA"}
                  </Button>

                  {isFreePlan && (
                    <span className="absolute -top-2 -right-2 bg-gradient-to-r from-yellow-400 to-orange-500 text-white text-[10px] px-2 py-0.5 rounded-full shadow">
                      Solo planes de pago
                    </span>
                  )}
                </div>
                <Button
                  type="button"
                  onClick={onClose}
                  className="bg-red-500 hover:bg-red-600 text-white"
                >
                  Cancelar
                </Button>

                <Button
                  type="submit"
                  className="bg-blue-600 hover:bg-blue-700 text-white"
                  disabled={loading}
                >
                  {isLoading ? "Guardando..." : "Guardar"}
                </Button>
              </div>
            </form>
          </CardContent>
        </Card>
      </div>
      {/* Modal confirmación IA */}
      {showCategoriaPrompt && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50 px-4">
          <div className="bg-white p-5 rounded-xl shadow-lg w-full max-w-sm space-y-4">
            <h3 className="text-lg font-semibold">
              Confirmar generación con IA
            </h3>

            <p className="text-sm text-gray-600">
              Se generará automáticamente la hoja de vida usando:
            </p>

            <ul className="text-sm text-gray-700 list-disc pl-5">
              <li>Categoría del modelo</li>
              <li>Marca seleccionada</li>
              <li>Modelo seleccionado</li>
            </ul>

            <div className="flex justify-end gap-2">
              <Button
                variant="outline"
                onClick={() => setShowCategoriaPrompt(false)}
              >
                Cancelar
              </Button>

              <Button
                onClick={async () => {
                  setShowCategoriaPrompt(false);
                  setLoading(true);

                  try {
                    const res = await axios.post(
                      `${API}/ia/hojavida`,
                      { marcaId, modeloId, categoriaId },
                      { headers: { Authorization: `Bearer ${token}` } },
                    );

                    setForm((f) => ({ ...f, ...res.data }));
                    toast.info("Hoja de vida generada con IA");
                  } catch {
                    toast.error("No se pudo generar con IA");
                  } finally {
                    setLoading(false);
                  }
                }}
              >
                Generar
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MantenimientoModal;
